import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/user-pool'
import {
  GetWorkspaceByIdQueryVariables,
  GetWorkspaceLogoUploadUrlQuery
} from '~workspace/types/__generated/gql/graphql'

const query = /* GraphQL */ `
  query GetWorkspaceLogoUploadUrl($id: ID!) {
    getWorkspaceLogoUploadUrl(id: $id) {
      uploadUrl
      formFieldsJson
      path
    }
  }
`

export type GetWorkspaceLogoUploadUrlResults =
  GetWorkspaceLogoUploadUrlQuery['getWorkspaceLogoUploadUrl']
export type GetWorkspaceLogoUploadUrlVariables = GetWorkspaceByIdQueryVariables

export const useGetWorkspaceLogoUploadUrl = (): UseMutationResult<
  GetWorkspaceLogoUploadUrlResults,
  Error,
  GetWorkspaceLogoUploadUrlVariables
> => {
  return useMutation({
    mutationKey: ['getWorkspaceLogoUploadUrl'],
    mutationFn: async (variables: GetWorkspaceLogoUploadUrlVariables) => {
      const data = await graphql<
        GetWorkspaceLogoUploadUrlQuery,
        GetWorkspaceLogoUploadUrlVariables
      >({
        query,
        variables: variables
      })

      return data?.getWorkspaceLogoUploadUrl
    }
  })
}
